import { callGetApiToServer } from '../callApi';

export async function getAllAdminCharityProgram(authtoken, charityId, skipNumber, limitNumber) {
	try {
		let header = {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			authorization: 'Berear ' + authtoken,
		};

		let endUrl = 'v1/auth/list-admin-charity-program/' + charityId + '/' + skipNumber + '/' + limitNumber;

		let responseData = await callGetApiToServer(header, 'GET', endUrl);

		return responseData;
	} catch (err) {
		throw err;
	}
}
